import { useMemo } from "react";

export const shallUseTestMode = () => {
  return (
    window.location.host.includes("localhost") ||
    window.location.host.includes("rtc-widget-frontend.k8s") ||
    window.location.search.includes("rtcForceDev")
  );
};

export const useTestMode = () => {
  const isTestMode = useMemo(() => shallUseTestMode(), []);

  const testArticleId = useMemo(() => {
    if (!isTestMode) {
      return "";
    }

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("rtc-test");
    return id?.length === 8 ? id : "29494981";
  }, []);

  return {
    isTestMode,
    testArticleId,
  };
};
